@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.sidebar {
  display: flex;
  width: 288px;
  min-width: 200px;
  flex-shrink: 1;
  height: 100%;
}
